import ProductCard from '@Components/ProductCard';
import ProductCardLoader from '@Components/ProductCard/ProductCard.loader';
import useTranslation from 'next-translate/useTranslation';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { ProductList } from './MyWishlist.styled';

type Props = {};
export default function MyWishlist({}: Props) {
  const { t } = useTranslation('Profile');
  const { data: wishListData } = useSelector((state: RootState) => state.profileWishlist);
  return (
    <>
      <ProductList>
        {wishListData
          ? wishListData.map((product) => <ProductCard data={product} key={product.id} />)
          : [...new Array(8)].map((_, i) => <ProductCardLoader key={i + '_Landing_SPECIAL'} />)}
      </ProductList>
    </>
  );
}
